var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDD28Working",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arrows_SVG",
    transform: "translate(-151.000000, -15.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(151.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    transform: "translate(7.000000, 7.000000) rotate(-180.000000) translate(-7.000000, -7.000000) ",
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#EA4335",
    fillRule: "nonzero",
    transform: "translate(7.000000, 6.500000) rotate(-360.000000) translate(-7.000000, -6.500000) ",
    points: "13 4.40880503 11.4724409 3 7 7.24414416 2.52755906 3 1 4.40880503 7 10"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/down.4221af4811f8f90ac75670c82ae6cb2c.svg";
export { ForwardRef as ReactComponent };